import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125, _templateObject126, _templateObject127, _templateObject128;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */

export var CacheControlScope;

(function (CacheControlScope) {
  CacheControlScope["Private"] = "PRIVATE";
  CacheControlScope["Public"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));

export var EpisodeType;

(function (EpisodeType) {
  EpisodeType["Catchup"] = "CATCHUP";
  EpisodeType["LiveBefore"] = "LIVE_BEFORE";
  EpisodeType["LiveOnair"] = "LIVE_ONAIR";
  EpisodeType["Video"] = "VIDEO";
})(EpisodeType || (EpisodeType = {}));

export var TermType;

(function (TermType) {
  TermType["Optional"] = "OPTIONAL";
  TermType["Required"] = "REQUIRED";
})(TermType || (TermType = {}));

export var DeviceInfoFieldsFragmentDoc = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment deviceInfoFields on DeviceInfo {\n  browser {\n    major\n    name\n    version\n  }\n  deviceType\n  deviceVendor\n  isAndroid\n  isBot\n  isChrome\n  isChromeOS\n  isDesktop\n  isEdge\n  isFirefox\n  isIE\n  isIOS\n  isIPad\n  isIPhone\n  isMac\n  isMobile\n  isSafari\n  isTablet\n  isWindows\n  os {\n    major\n    name\n    version\n  }\n  ua\n  isWebView @client(always: true)\n  isApp\n}\n    "])));
export var PageInfoFieldsFragmentDoc = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    fragment pageInfoFields on PageInfo {\n  offset\n  limit\n  totalCount\n  hasNextPage\n}\n    "])));
export var AdvertisingFieldsFragmentDoc = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    fragment advertisingFields on Advert {\n  id\n  name\n  description\n  url\n  targetBlank\n  sort\n  thumbnailUrl\n  copyright\n}\n    "])));
export var ChannelMetaFieldsFragmentDoc = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    fragment channelMetaFields on ChannelMeta {\n  id\n  schema_key\n  name\n  header\n  description\n  thumbnailUrl\n  copyright\n  delivery_start_at\n  delivery_end_at\n  rights_control_type\n  rating\n  isAllowedRating\n  rights {\n    ... on Right {\n      id\n      name\n      price\n      contractAllowed\n    }\n  }\n  genres {\n    id\n    name\n  }\n  adultFlag\n  meta_keywords\n  meta_description\n  live_flag\n  video_flag\n  heroImage {\n    pc\n    mb\n  }\n  distributor\n}\n    "])));
export var EpisodeMetaFieldsFragmentDoc = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    fragment episodeMetaFields on EpisodeMeta {\n  id\n  schema_key\n  name\n  header\n  description\n  thumbnailUrl\n  copyright\n  delivery_start_at\n  delivery_end_at\n  rights_control_type\n  rating\n  isAllowedRating\n  rights {\n    ... on Right {\n      id\n      name\n      price\n    }\n  }\n  genres {\n    id\n    name\n  }\n  adultFlag\n  production_country\n  production_year\n  distributor\n  cast\n  staff\n  duration\n  meta_keywords\n  meta_description\n  channel {\n    ... on ChannelMeta {\n      id\n      name\n    }\n  }\n  tvShow {\n    ... on TVShowMeta {\n      id\n      name\n      episode_num\n    }\n  }\n  area_control_flag\n  is_live\n  recommend\n  source_epg_id\n  plalaFlag\n}\n    "])));
export var LiveMetaFieldsFragmentDoc = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    fragment liveMetaFields on LiveMeta {\n  id\n  schema_key\n  name\n  header\n  description\n  thumbnailUrl\n  copyright\n  delivery_start_at\n  delivery_end_at\n  rights_control_type\n  parents {\n    ... on TVShowMeta {\n      id\n      name\n      episode_num\n    }\n  }\n  rating\n  isAllowedRating\n  rights {\n    ... on Right {\n      id\n      name\n      price\n    }\n  }\n  genres {\n    id\n    name\n  }\n  adultFlag\n  production_country\n  production_year\n  distributor\n  cast\n  staff\n  duration\n  meta_keywords\n  meta_description\n  channel {\n    ... on ChannelMeta {\n      id\n      name\n    }\n  }\n  tvShow {\n    ... on TVShowMeta {\n      id\n      name\n      episode_num\n    }\n  }\n  area_control_flag\n  is_live\n  recommend\n  start_over_flag\n  catch_up_flag\n  encode_start_date\n  encode_end_date\n  source_epg_id\n  plalaFlag\n}\n    "])));
export var TvShowMetaFieldsFragmentDoc = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    fragment tvShowMetaFields on TVShowMeta {\n  id\n  schema_key\n  name\n  header\n  description\n  thumbnailUrl\n  copyright\n  delivery_start_at\n  delivery_end_at\n  rights_control_type\n  rating\n  isAllowedRating\n  rights {\n    ... on Right {\n      id\n      name\n      price\n      rights_control_type\n    }\n  }\n  genres {\n    id\n    name\n  }\n  adultFlag\n  production_country\n  production_year\n  cast\n  staff\n  episode_num\n  meta_keywords\n  meta_description\n  channel {\n    ... on ChannelMeta {\n      id\n      name\n    }\n  }\n  distributor\n}\n    "])));
export var EntitlementFieldsFragmentDoc = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    fragment entitlementFields on Entitlement {\n  id\n  user_id\n  right_id\n  start_at\n  end_at\n  exercised_at\n  exercise_duration\n  exercise_duration_unit\n  exercisable_start_at\n  exercisable_end_at\n  suspend_flag\n}\n    "])));
export var CampaignFieldsFragmentDoc = gql(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    fragment campaignFields on Campaign {\n  id\n  name\n  header\n  description\n  validityStartAt\n  validityEndAt\n  broadcastDiscount\n  discountApplyCount\n}\n    "])));
export var CoursePriceFieldsFragmentDoc = gql(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    fragment coursePriceFields on CoursePrice {\n  id\n  price\n  payment_amount\n  validity_start_at\n  validity_end_at\n  campaignId\n  campaign {\n    ...campaignFields\n  }\n}\n    ", ""])), CampaignFieldsFragmentDoc);
export var CourseFieldsFragmentDoc = gql(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    fragment courseFields on Course {\n  id\n  name\n  thumbnailUrl\n  description\n  validity_start_at\n  validity_end_at\n  price\n  priceWithoutTax\n  defaultPrice\n  defaultPriceWithoutTax\n  discount_price\n  active_pricing {\n    ... on CoursePrice {\n      ...coursePriceFields\n    }\n  }\n  rightIds\n  trial_flag\n  trial_date\n  trialTerm\n  trial_term_unit\n  trialTermText\n  trialText\n  trialDate\n  ref_id\n  valuePlan\n  questionId\n  trialCampaignFlag\n  contractAllowed\n}\n    ", ""])), CoursePriceFieldsFragmentDoc);
export var ProductFieldsFragmentDoc = gql(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    fragment productFields on Product {\n  id\n  name\n  thumbnailUrl\n  description\n  product_type\n  sales_start_at\n  sales_end_at\n  price\n  priceWithoutTax\n  rightIds\n  purchaseAllowed\n}\n    "])));
export var RightFieldsFragmentDoc = gql(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    fragment rightFields on Right {\n  id\n  name\n  exercise_term\n  exercise_term_unit\n  view_term\n  view_term_unit\n  view_limit_date\n  validity_start_at\n  validity_end_at\n  price\n  discount_price\n  isSvod\n  package_type\n  discount_description\n  contractAllowed\n}\n    "])));
export var RecommendArticleFieldsFragmentDoc = gql(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    fragment recommendArticleFields on RecommendArticle {\n  courses {\n    ... on Course {\n      ...courseFields\n    }\n  }\n  products {\n    ... on Product {\n      ...productFields\n      right {\n        ... on Right {\n          ...rightFields\n        }\n      }\n    }\n  }\n}\n    ", "\n", "\n", ""])), CourseFieldsFragmentDoc, ProductFieldsFragmentDoc, RightFieldsFragmentDoc);
export var SubscriptionFieldsFragmentDoc = gql(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    fragment subscriptionFields on Subscription {\n  subscription_id\n  course_id\n  payment_method_id\n  payment_instrument_id\n  initialTransactionAt\n  nextTransactionAt\n  status\n  course {\n    ... on Course {\n      ...courseFields\n    }\n  }\n  payment_instrument {\n    values {\n      card_number\n      card_type\n    }\n  }\n  withdraw_at\n  trialStartAt\n  trialEndAt\n  entitlements {\n    right_id\n  }\n  suspend_flag\n}\n    ", ""])), CourseFieldsFragmentDoc);
export var VoucherFildsFragmentDoc = gql(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    fragment voucherFilds on Voucher {\n  id\n  name\n  description\n  discountPrice\n  limitPrice\n  trialExtendTerm\n  trialExtendTermUnit\n  trialExtendEndOf\n  validityStartAt\n  validityEndAt\n}\n    "])));
export var VoucherCodeFieldsFragmentDoc = gql(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    fragment voucherCodeFields on VoucherCode {\n  id\n  code\n  voucherId\n  validityStartAt\n  validityEndAt\n  expire_at\n  isAvailable\n  voucher {\n    ...voucherFilds\n  }\n}\n    ", ""])), VoucherFildsFragmentDoc);
export var EstimateFieldsFragmentDoc = gql(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    fragment estimateFields on SubscriptionEstimate {\n  subscription {\n    ...subscriptionFields\n  }\n  voucherCode {\n    ...voucherCodeFields\n  }\n  coursePricings {\n    ...coursePriceFields\n  }\n  paymentPrice {\n    ...coursePriceFields\n  }\n  broadcastDiscountCampaignPrice {\n    ...coursePriceFields\n  }\n  campaignPrice {\n    ...coursePriceFields\n  }\n  error\n}\n    ", "\n", "\n", ""])), SubscriptionFieldsFragmentDoc, VoucherCodeFieldsFragmentDoc, CoursePriceFieldsFragmentDoc);
export var TermsFieldsFragmentDoc = gql(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    fragment termsFields on Term {\n  id_key\n  display_name\n  required\n  current_revision {\n    unique_key\n    number\n    url\n    agreement {\n      agreement_id\n      user_id\n      term_id\n      term_revision_number\n    }\n  }\n}\n    "])));
export var UserFavoritesFieldsFragmentDoc = gql(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    fragment userFavoritesFields on UserFavorites {\n  id\n  metas {\n    ... on EpisodeMeta {\n      id\n    }\n    ... on LiveMeta {\n      id\n    }\n    ... on TVShowMeta {\n      id\n    }\n    ... on ChannelMeta {\n      id\n    }\n  }\n}\n    "])));
export var ProfileFieldsFragmentDoc = gql(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    fragment profileFields on ProfileUser {\n  uuid\n  id\n  displayName: display_name\n  birthday\n  age\n  sex\n  ownerProfile\n  needPasscode\n  icon\n  rating\n}\n    "])));
export var AccountFieldsFragmentDoc = gql(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    fragment accountFields on AccountUser {\n  id\n  uuid\n  displayName: display_name\n  birthday\n  age\n  sex\n  mailAddress: mail_address\n  firstName: first_name\n  lastName: last_name\n  fullName\n  rightsFreeFlag: rights_free_flag\n  currentProfile {\n    ...profileFields\n  }\n  profiles {\n    ...profileFields\n  }\n  test_flg\n  mySkpRelation\n  mySkpEmail\n  hashedUserId\n}\n    ", ""])), ProfileFieldsFragmentDoc);
export var AdultModeDocument = gql(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    query AdultMode {\n  adultMode\n}\n    "])));
/**
 * __useAdultModeQuery__
 *
 * To run a query within a React component, call `useAdultModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdultModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdultModeQuery({
 *   variables: {
 *   },
 * });
 */

export function useAdultModeQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(AdultModeDocument, options);
}
export function useAdultModeLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(AdultModeDocument, options);
}
export var AppInitDocument = gql(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    query AppInit {\n  adultMode\n  deviceInfo {\n    ...deviceInfoFields\n  }\n  user {\n    ...accountFields\n  }\n  favorites: userFavorites {\n    ...userFavoritesFields\n  }\n}\n    ", "\n", "\n", ""])), DeviceInfoFieldsFragmentDoc, AccountFieldsFragmentDoc, UserFavoritesFieldsFragmentDoc);
/**
 * __useAppInitQuery__
 *
 * To run a query within a React component, call `useAppInitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInitQuery({
 *   variables: {
 *   },
 * });
 */

export function useAppInitQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(AppInitDocument, options);
}
export function useAppInitLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(AppInitDocument, options);
}
export var GenreAttributesDocument = gql(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    query GenreAttributes($ids: [Int]) {\n  genreAttributes(ids: $ids) {\n    attributes {\n      name\n      id\n    }\n  }\n}\n    "])));
/**
 * __useGenreAttributesQuery__
 *
 * To run a query within a React component, call `useGenreAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenreAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenreAttributesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */

export function useGenreAttributesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(GenreAttributesDocument, options);
}
export function useGenreAttributesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(GenreAttributesDocument, options);
}
export var CanvasDocument = gql(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    query canvas($idKey: String, $offset: Int, $limit: Int, $withMeta: Boolean = false) {\n  canvas(idKey: $idKey, offset: $offset, limit: $limit) {\n    data {\n      type\n      id\n    }\n    meta @include(if: $withMeta) {\n      title\n      robots\n      keywords\n      description\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", ""])), PageInfoFieldsFragmentDoc);
/**
 * __useCanvasQuery__
 *
 * To run a query within a React component, call `useCanvasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvasQuery({
 *   variables: {
 *      idKey: // value for 'idKey'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      withMeta: // value for 'withMeta'
 *   },
 * });
 */

export function useCanvasQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(CanvasDocument, options);
}
export function useCanvasLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(CanvasDocument, options);
}
export var ChannelsWithContractStatusDocument = gql(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    query ChannelsWithContractStatus($offset: Int, $limit: Int, $filter: JSONObject, $sort: String, $uuid: String) {\n  channelsWithContractStatus(\n    offset: $offset\n    limit: $limit\n    filter: $filter\n    sort: $sort\n    uuid: $uuid\n  ) {\n    data {\n      ... on ChannelMeta {\n        ...channelMetaFields\n      }\n      contractStatus\n      contractAllowed\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", ""])), ChannelMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useChannelsWithContractStatusQuery__
 *
 * To run a query within a React component, call `useChannelsWithContractStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsWithContractStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsWithContractStatusQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */

export function useChannelsWithContractStatusQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ChannelsWithContractStatusDocument, options);
}
export function useChannelsWithContractStatusLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ChannelsWithContractStatusDocument, options);
}
export var ChannelFeatureEpisodesDocument = gql(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    query ChannelFeatureEpisodes($id: Int, $offset: Int, $limit: Int) {\n  channelFeatureEpisodes(id: $id, offset: $offset, limit: $limit) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useChannelFeatureEpisodesQuery__
 *
 * To run a query within a React component, call `useChannelFeatureEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelFeatureEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelFeatureEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useChannelFeatureEpisodesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ChannelFeatureEpisodesDocument, options);
}
export function useChannelFeatureEpisodesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ChannelFeatureEpisodesDocument, options);
}
export var ChannelDetailDocument = gql(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n    query ChannelDetail($id: Int, $withTabMenu: Boolean = false, $withEntitlement: Boolean = false) {\n  channel: channelDetail(id: $id) {\n    ... on ChannelMeta {\n      ...channelMetaFields\n    }\n    contractAllowed\n    tabMenu @include(if: $withTabMenu) {\n      id\n      title\n      url\n      values\n    }\n  }\n  entitlements(metaId: $id) @include(if: $withEntitlement) {\n    ...entitlementFields\n  }\n  course: courseByMetaId(metaId: $id) @include(if: $withEntitlement) {\n    ...courseFields\n  }\n}\n    ", "\n", "\n", ""])), ChannelMetaFieldsFragmentDoc, EntitlementFieldsFragmentDoc, CourseFieldsFragmentDoc);
/**
 * __useChannelDetailQuery__
 *
 * To run a query within a React component, call `useChannelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTabMenu: // value for 'withTabMenu'
 *      withEntitlement: // value for 'withEntitlement'
 *   },
 * });
 */

export function useChannelDetailQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ChannelDetailDocument, options);
}
export function useChannelDetailLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ChannelDetailDocument, options);
}
export var ChannelEpisodeSearchDocument = gql(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    query ChannelEpisodeSearch($keyword: String, $id: Int, $episodeType: EpisodeType, $offset: Int, $limit: Int) {\n  channelEpisodeSearch(\n    keyword: $keyword\n    id: $id\n    episodeType: $episodeType\n    offset: $offset\n    limit: $limit\n  ) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useChannelEpisodeSearchQuery__
 *
 * To run a query within a React component, call `useChannelEpisodeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelEpisodeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelEpisodeSearchQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      id: // value for 'id'
 *      episodeType: // value for 'episodeType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useChannelEpisodeSearchQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ChannelEpisodeSearchDocument, options);
}
export function useChannelEpisodeSearchLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ChannelEpisodeSearchDocument, options);
}
export var ChannelLiveScheduleDocument = gql(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n    query ChannelLiveSchedule($id: Int, $day: String, $offset: Int, $limit: Int) {\n  channelLiveSchedule(id: $id, day: $day, offset: $offset, limit: $limit) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useChannelLiveScheduleQuery__
 *
 * To run a query within a React component, call `useChannelLiveScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLiveScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLiveScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      day: // value for 'day'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useChannelLiveScheduleQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ChannelLiveScheduleDocument, options);
}
export function useChannelLiveScheduleLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ChannelLiveScheduleDocument, options);
}
export var ChannelLinearEpisodesDocument = gql(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n    query ChannelLinearEpisodes($id: Int, $offset: Int, $limit: Int, $filter: JSONObject) {\n  channelLinearEpisodes(id: $id, offset: $offset, limit: $limit, filter: $filter) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useChannelLinearEpisodesQuery__
 *
 * To run a query within a React component, call `useChannelLinearEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLinearEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLinearEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */

export function useChannelLinearEpisodesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ChannelLinearEpisodesDocument, options);
}
export function useChannelLinearEpisodesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ChannelLinearEpisodesDocument, options);
}
export var TvShowEpisodesDocument = gql(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n    query TvShowEpisodes($id: Int, $offset: Int, $limit: Int, $filter: JSONObject, $sort: JSONObject) {\n  children(id: $id, offset: $offset, limit: $limit, filter: $filter, sort: $sort) {\n    data {\n      ...episodeMetaFields\n      ...liveMetaFields\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useTvShowEpisodesQuery__
 *
 * To run a query within a React component, call `useTvShowEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTvShowEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTvShowEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */

export function useTvShowEpisodesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(TvShowEpisodesDocument, options);
}
export function useTvShowEpisodesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(TvShowEpisodesDocument, options);
}
export var CourseByRightIdDocument = gql(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n    query CourseByRightId($rightId: Int) {\n  courseByRightId(rightId: $rightId) {\n    ...courseFields\n  }\n}\n    ", ""])), CourseFieldsFragmentDoc);
/**
 * __useCourseByRightIdQuery__
 *
 * To run a query within a React component, call `useCourseByRightIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByRightIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByRightIdQuery({
 *   variables: {
 *      rightId: // value for 'rightId'
 *   },
 * });
 */

export function useCourseByRightIdQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(CourseByRightIdDocument, options);
}
export function useCourseByRightIdLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(CourseByRightIdDocument, options);
}
export var CourseByIdDocument = gql(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n    query CourseById($courseId: Int) {\n  course: courseById(courseId: $courseId) {\n    ... on Course {\n      ...courseFields\n    }\n  }\n}\n    ", ""])), CourseFieldsFragmentDoc);
/**
 * __useCourseByIdQuery__
 *
 * To run a query within a React component, call `useCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */

export function useCourseByIdQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(CourseByIdDocument, options);
}
export function useCourseByIdLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(CourseByIdDocument, options);
}
export var DeviceInfoDocument = gql(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n    query DeviceInfo {\n  deviceInfo {\n    ...deviceInfoFields\n  }\n}\n    ", ""])), DeviceInfoFieldsFragmentDoc);
/**
 * __useDeviceInfoQuery__
 *
 * To run a query within a React component, call `useDeviceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceInfoQuery({
 *   variables: {
 *   },
 * });
 */

export function useDeviceInfoQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(DeviceInfoDocument, options);
}
export function useDeviceInfoLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(DeviceInfoDocument, options);
}
export var GetEntitledStoreEpisodesDocument = gql(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n    query GetEntitledStoreEpisodes($offset: Int, $limit: Int) {\n  getEntitledStoreEpisodes(offset: $offset, limit: $limit) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useGetEntitledStoreEpisodesQuery__
 *
 * To run a query within a React component, call `useGetEntitledStoreEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitledStoreEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitledStoreEpisodesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useGetEntitledStoreEpisodesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(GetEntitledStoreEpisodesDocument, options);
}
export function useGetEntitledStoreEpisodesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(GetEntitledStoreEpisodesDocument, options);
}
export var GenrePaletteEpisodesDocument = gql(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n    query GenrePaletteEpisodes($channel: Int, $genre: [Int], $offset: Int, $limit: Int, $sortOrder: String, $type: String) {\n  genrePaletteEpisodes(\n    channel: $channel\n    genre: $genre\n    offset: $offset\n    limit: $limit\n    sortOrder: $sortOrder\n    type: $type\n  ) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useGenrePaletteEpisodesQuery__
 *
 * To run a query within a React component, call `useGenrePaletteEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenrePaletteEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenrePaletteEpisodesQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      genre: // value for 'genre'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      type: // value for 'type'
 *   },
 * });
 */

export function useGenrePaletteEpisodesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(GenrePaletteEpisodesDocument, options);
}
export function useGenrePaletteEpisodesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(GenrePaletteEpisodesDocument, options);
}
export var EntitledDocument = gql(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n    query Entitled($channelId: Int, $contentType: String, $offset: Int, $limit: Int) {\n  entitled(\n    channelId: $channelId\n    contentType: $contentType\n    offset: $offset\n    limit: $limit\n  ) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n      ... on TVShowMeta {\n        ...tvShowMetaFields\n      }\n      ... on ChannelMeta {\n        ...channelMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, TvShowMetaFieldsFragmentDoc, ChannelMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useEntitledQuery__
 *
 * To run a query within a React component, call `useEntitledQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitledQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      contentType: // value for 'contentType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useEntitledQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(EntitledDocument, options);
}
export function useEntitledLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(EntitledDocument, options);
}
export var HtmlSnippetDocument = gql(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n    query HtmlSnippet($id: Int, $idKey: String) {\n  htmlSnippet(id: $id, idKey: $idKey) {\n    id\n    content\n    style\n    javascript\n  }\n}\n    "])));
/**
 * __useHtmlSnippetQuery__
 *
 * To run a query within a React component, call `useHtmlSnippetQuery` and pass it any options that fit your needs.
 * When your component renders, `useHtmlSnippetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHtmlSnippetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      idKey: // value for 'idKey'
 *   },
 * });
 */

export function useHtmlSnippetQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(HtmlSnippetDocument, options);
}
export function useHtmlSnippetLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(HtmlSnippetDocument, options);
}
export var InformationsDocument = gql(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n    query Informations($key: String, $offset: Int, $limit: Int) {\n  informations(key: $key, offset: $offset, limit: $limit) {\n    data {\n      id\n      title\n      url\n      targetBlank\n      date\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", ""])), PageInfoFieldsFragmentDoc);
/**
 * __useInformationsQuery__
 *
 * To run a query within a React component, call `useInformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInformationsQuery({
 *   variables: {
 *      key: // value for 'key'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useInformationsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(InformationsDocument, options);
}
export function useInformationsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(InformationsDocument, options);
}
export var MySkpAuthLoginDocument = gql(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n    mutation MySkpAuthLogin($loginid: String!, $password: String!, $signature: String!) {\n  mySkpLogin(loginid: $loginid, password: $password, signature: $signature) {\n    token\n    user {\n      ...accountFields\n    }\n    error {\n      type\n      code\n      message\n      token\n    }\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useMySkpAuthLoginMutation__
 *
 * To run a mutation, you first call `useMySkpAuthLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMySkpAuthLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mySkpAuthLoginMutation, { data, loading, error }] = useMySkpAuthLoginMutation({
 *   variables: {
 *      loginid: // value for 'loginid'
 *      password: // value for 'password'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useMySkpAuthLoginMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(MySkpAuthLoginDocument, options);
}
export var MySkpTokenVerifyDocument = gql(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n    query MySkpTokenVerify($token: String!) {\n  mySkpTokenVerify(token: $token) {\n    result\n    attrs {\n      mailAddress\n      first_name\n      last_name\n      birthday\n      sex\n    }\n  }\n}\n    "])));
/**
 * __useMySkpTokenVerifyQuery__
 *
 * To run a query within a React component, call `useMySkpTokenVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySkpTokenVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySkpTokenVerifyQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */

export function useMySkpTokenVerifyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(MySkpTokenVerifyDocument, options);
}
export function useMySkpTokenVerifyLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(MySkpTokenVerifyDocument, options);
}
export var MySkpAccountSignupDocument = gql(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n    mutation MySkpAccountSignup($token: String!, $mailAddress: String!, $password: String!, $firstName: String!, $lastName: String!, $birthday: String!, $sex: String!, $terms: String!, $signature: String!) {\n  mySkpSignup(\n    token: $token\n    mailAddress: $mailAddress\n    password: $password\n    firstName: $firstName\n    lastName: $lastName\n    birthday: $birthday\n    sex: $sex\n    terms: $terms\n    signature: $signature\n  ) {\n    auth {\n      token\n      user {\n        ...accountFields\n      }\n    }\n    relationResult\n    hasContinuousProduct\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useMySkpAccountSignupMutation__
 *
 * To run a mutation, you first call `useMySkpAccountSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMySkpAccountSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mySkpAccountSignupMutation, { data, loading, error }] = useMySkpAccountSignupMutation({
 *   variables: {
 *      token: // value for 'token'
 *      mailAddress: // value for 'mailAddress'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      terms: // value for 'terms'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useMySkpAccountSignupMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(MySkpAccountSignupDocument, options);
}
export var MySkpRelationDocument = gql(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n    mutation MySkpRelation($token: String!, $mailAddress: String!, $password: String!, $signature: String!) {\n  mySkpRelation(\n    token: $token\n    mailAddress: $mailAddress\n    password: $password\n    signature: $signature\n  ) {\n    auth {\n      token\n      user {\n        ...accountFields\n      }\n    }\n    relationResult\n    hasContinuousProduct\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useMySkpRelationMutation__
 *
 * To run a mutation, you first call `useMySkpRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMySkpRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mySkpRelationMutation, { data, loading, error }] = useMySkpRelationMutation({
 *   variables: {
 *      token: // value for 'token'
 *      mailAddress: // value for 'mailAddress'
 *      password: // value for 'password'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useMySkpRelationMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(MySkpRelationDocument, options);
}
export var MySkpRelationAuthDocument = gql(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n    mutation MySkpRelationAuth($mailAddress: String!, $password: String!) {\n  mySkpRelationAuth(mailAddress: $mailAddress, password: $password) {\n    auth {\n      token\n      user {\n        ...accountFields\n      }\n    }\n    relationResult\n    hasContinuousProduct\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useMySkpRelationAuthMutation__
 *
 * To run a mutation, you first call `useMySkpRelationAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMySkpRelationAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mySkpRelationAuthMutation, { data, loading, error }] = useMySkpRelationAuthMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useMySkpRelationAuthMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(MySkpRelationAuthDocument, options);
}
export var ProductOrdersDocument = gql(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n    query ProductOrders($with_order: Boolean, $with_payment_instrument: Boolean, $with_entitlements: Boolean, $type: String) {\n  productOrders(\n    with_order: $with_order\n    with_payment_instrument: $with_payment_instrument\n    with_entitlements: $with_entitlements\n    type: $type\n  ) {\n    data {\n      name\n      order_id\n      created_at\n      order {\n        finished_at\n        payment_amount\n        payment_instrument {\n          payment_method_id\n          values {\n            card_type\n            card_number\n          }\n        }\n      }\n      entitlements {\n        end_at\n        right_id\n      }\n    }\n  }\n}\n    "])));
/**
 * __useProductOrdersQuery__
 *
 * To run a query within a React component, call `useProductOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOrdersQuery({
 *   variables: {
 *      with_order: // value for 'with_order'
 *      with_payment_instrument: // value for 'with_payment_instrument'
 *      with_entitlements: // value for 'with_entitlements'
 *      type: // value for 'type'
 *   },
 * });
 */

export function useProductOrdersQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ProductOrdersDocument, options);
}
export function useProductOrdersLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ProductOrdersDocument, options);
}
export var OrdersDocument = gql(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n    query Orders($offset: Int, $limit: Int, $adultFlag: Boolean) {\n  orders(offset: $offset, limit: $limit, adultFlag: $adultFlag) {\n    data {\n      name\n      created_at\n      payment_amount\n      order_type\n      payment_instrument {\n        payment_method_id\n        values {\n          card_type\n          card_number\n        }\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", ""])), PageInfoFieldsFragmentDoc);
/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      adultFlag: // value for 'adultFlag'
 *   },
 * });
 */

export function useOrdersQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(OrdersDocument, options);
}
export function useOrdersLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(OrdersDocument, options);
}
export var PaletteDocument = gql(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n    query Palette($id: Int, $offset: Int, $limit: Int) {\n  palette(id: $id) {\n    palette_id\n    name\n    id_key\n    header\n    description\n    schema_id\n    schema\n    values\n  }\n  paletteObjects(id: $id, offset: $offset, limit: $limit) {\n    data {\n      id\n      type\n      meta {\n        ... on EpisodeMeta {\n          ...episodeMetaFields\n        }\n        ... on LiveMeta {\n          ...liveMetaFields\n        }\n        ... on TVShowMeta {\n          ...tvShowMetaFields\n        }\n        ... on ChannelMeta {\n          ...channelMetaFields\n        }\n      }\n      advertising {\n        ...advertisingFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, TvShowMetaFieldsFragmentDoc, ChannelMetaFieldsFragmentDoc, AdvertisingFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __usePaletteQuery__
 *
 * To run a query within a React component, call `usePaletteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaletteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaletteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function usePaletteQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PaletteDocument, options);
}
export function usePaletteLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PaletteDocument, options);
}
export var PaletteObjectsDocument = gql(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n    query PaletteObjects($id: Int, $offset: Int, $limit: Int) {\n  paletteObjects(id: $id, offset: $offset, limit: $limit) {\n    data {\n      id\n      type\n      meta {\n        ... on EpisodeMeta {\n          ...episodeMetaFields\n        }\n        ... on LiveMeta {\n          ...liveMetaFields\n        }\n        ... on TVShowMeta {\n          ...tvShowMetaFields\n        }\n        ... on ChannelMeta {\n          ...channelMetaFields\n        }\n      }\n      advertising {\n        ...advertisingFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, TvShowMetaFieldsFragmentDoc, ChannelMetaFieldsFragmentDoc, AdvertisingFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __usePaletteObjectsQuery__
 *
 * To run a query within a React component, call `usePaletteObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaletteObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaletteObjectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function usePaletteObjectsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PaletteObjectsDocument, options);
}
export function usePaletteObjectsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PaletteObjectsDocument, options);
}
export var PaymentInstrumentsDocument = gql(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n    query PaymentInstruments($type: String) {\n  paymentInstruments(type: $type) {\n    default_flag\n    payment_method {\n      name\n    }\n    payment_method_id\n    payment_instrument_id\n    ref_id\n    values {\n      card_number\n      card_type\n      expiry_date\n    }\n  }\n}\n    "])));
/**
 * __usePaymentInstrumentsQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */

export function usePaymentInstrumentsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PaymentInstrumentsDocument, options);
}
export function usePaymentInstrumentsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PaymentInstrumentsDocument, options);
}
export var PaymentInstrumentInfoDocument = gql(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n    query PaymentInstrumentInfo($id: Int) {\n  paymentInstrumentInfo(id: $id) {\n    default_flag\n    payment_method {\n      name\n    }\n    payment_method_id\n    payment_instrument_id\n    ref_id\n    values {\n      card_number\n      card_type\n      expiry_date\n    }\n  }\n}\n    "])));
/**
 * __usePaymentInstrumentInfoQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */

export function usePaymentInstrumentInfoQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PaymentInstrumentInfoDocument, options);
}
export function usePaymentInstrumentInfoLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PaymentInstrumentInfoDocument, options);
}
export var PaymentInstrumentsCreateCreditCardRecaptchaV2Document = gql(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    mutation PaymentInstrumentsCreateCreditCardRecaptchaV2($payment_method_id: Int, $replace_flag: Boolean, $token: String, $token_key: String, $recaptchaTokenV2: String) {\n  paymentInstrumentsCreateCreditCardRecaptchaV2(\n    payment_method_id: $payment_method_id\n    replace_flag: $replace_flag\n    token: $token\n    token_key: $token_key\n    recaptchaTokenV2: $recaptchaTokenV2\n  ) {\n    payment_instrument_id\n    payment_method_id\n    status\n    error\n    recaptchaSuccessV2\n  }\n}\n    "])));

/**
 * __usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateCreditCardRecaptchaV2Mutation, { data, loading, error }] = usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      token: // value for 'token'
 *      token_key: // value for 'token_key'
 *      recaptchaTokenV2: // value for 'recaptchaTokenV2'
 *   },
 * });
 */
export function usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PaymentInstrumentsCreateCreditCardRecaptchaV2Document, options);
}
export var PaymentInstrumentsCreateCreditCardRecaptchaV3Document = gql(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n    mutation PaymentInstrumentsCreateCreditCardRecaptchaV3($payment_method_id: Int, $replace_flag: Boolean, $token: String, $token_key: String, $recaptchaTokenV3: String) {\n  paymentInstrumentsCreateCreditCardRecaptchaV3(\n    payment_method_id: $payment_method_id\n    replace_flag: $replace_flag\n    token: $token\n    token_key: $token_key\n    recaptchaTokenV3: $recaptchaTokenV3\n  ) {\n    payment_instrument_id\n    payment_method_id\n    status\n    error\n    recaptchaSuccessV3\n  }\n}\n    "])));

/**
 * __usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateCreditCardRecaptchaV3Mutation, { data, loading, error }] = usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      token: // value for 'token'
 *      token_key: // value for 'token_key'
 *      recaptchaTokenV3: // value for 'recaptchaTokenV3'
 *   },
 * });
 */
export function usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PaymentInstrumentsCreateCreditCardRecaptchaV3Document, options);
}
export var PaymentInstrumentsCreateOtherDocument = gql(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n    mutation PaymentInstrumentsCreateOther($payment_method_id: Int, $replace_flag: Boolean, $success_url: String, $cancel_url: String, $error_url: String, $tokenPayload: JSONObject) {\n  paymentInstrumentsCreateOther(\n    payment_method_id: $payment_method_id\n    replace_flag: $replace_flag\n    success_url: $success_url\n    cancel_url: $cancel_url\n    error_url: $error_url\n    tokenPayload: $tokenPayload\n  ) {\n    redirect_link\n    http_method\n    redirect_url\n    charset\n    form_data {\n      pay_method\n      merchant_id\n      service_id\n      cust_code\n      order_id\n      item_id\n      item_name\n      service_type\n      terminal_type\n      success_url\n      cancel_url\n      error_url\n      pagecon_url\n      free1\n      free2\n      free3\n      request_date\n      limit_second\n      sps_hashcode\n    }\n    error\n  }\n}\n    "])));

/**
 * __usePaymentInstrumentsCreateOtherMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateOtherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateOtherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateOtherMutation, { data, loading, error }] = usePaymentInstrumentsCreateOtherMutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *      error_url: // value for 'error_url'
 *      tokenPayload: // value for 'tokenPayload'
 *   },
 * });
 */
export function usePaymentInstrumentsCreateOtherMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PaymentInstrumentsCreateOtherDocument, options);
}
export var PaymentInstrumentsDeactivateDocument = gql(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n    mutation PaymentInstrumentsDeactivate($payment_instrument_id: Int) {\n  paymentInstrumentsDeactivate(payment_instrument_id: $payment_instrument_id) {\n    payment_instrument_id\n    error {\n      message\n    }\n  }\n}\n    "])));

/**
 * __usePaymentInstrumentsDeactivateMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsDeactivateMutation, { data, loading, error }] = usePaymentInstrumentsDeactivateMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */
export function usePaymentInstrumentsDeactivateMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PaymentInstrumentsDeactivateDocument, options);
}
export var PaymentInstrumentsSetDefaultDocument = gql(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n    mutation PaymentInstrumentsSetDefault($payment_instrument_id: Int) {\n  paymentInstrumentsSetDefault(payment_instrument_id: $payment_instrument_id) {\n    default_flag\n  }\n}\n    "])));

/**
 * __usePaymentInstrumentsSetDefaultMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsSetDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsSetDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsSetDefaultMutation, { data, loading, error }] = usePaymentInstrumentsSetDefaultMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */
export function usePaymentInstrumentsSetDefaultMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PaymentInstrumentsSetDefaultDocument, options);
}
export var AddPaymentInstrumentSendMailDocument = gql(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n    mutation AddPaymentInstrumentSendMail($paymentInstrumentId: Int) {\n  addPaymentInstrumentSendMail(paymentInstrumentId: $paymentInstrumentId) {\n    result\n  }\n}\n    "])));

/**
 * __useAddPaymentInstrumentSendMailMutation__
 *
 * To run a mutation, you first call `useAddPaymentInstrumentSendMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentInstrumentSendMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentInstrumentSendMailMutation, { data, loading, error }] = useAddPaymentInstrumentSendMailMutation({
 *   variables: {
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *   },
 * });
 */
export function useAddPaymentInstrumentSendMailMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AddPaymentInstrumentSendMailDocument, options);
}
export var PaymentMethodsDocument = gql(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n    query PaymentMethods {\n  paymentMethods {\n    name\n    payment_method_id\n    payment_method_type_name\n  }\n  paymentInstruments {\n    default_flag\n    payment_method {\n      name\n    }\n    payment_method_id\n    payment_instrument_id\n    ref_id\n    values {\n      card_number\n      card_type\n      expiry_date\n    }\n  }\n}\n    "])));
/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */

export function usePaymentMethodsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PaymentMethodsDocument, options);
}
export function usePaymentMethodsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PaymentMethodsDocument, options);
}
export var PlaybackAuthDocument = gql(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n    query PlaybackAuth($id: Int, $vuid: String, $sessionId: String, $fl: Int) {\n  playbackAuth(id: $id, vuid: $vuid, sessionId: $sessionId, fl: $fl) {\n    media {\n      media_id\n      uuid\n      ovp_id\n      ovp_video_id\n      thumbnail_tile_urls\n    }\n    rule {\n      playback_rule_id\n      enable_seek_flag\n      enable_cromecst_flag\n      enable_airplay_flag\n      enable_mirroring_flag\n      enable_external_monitor_flag\n      enable_catchup_flag\n      enable_start_over_flag\n      enable_pause_flag\n      enable_background_play_flag\n      enable_screen_capture_flag\n      enable_playback_rate_change_flag\n      enable_offline_play_flag\n      maximum_bitrate\n      minimum_bitrate\n    }\n    playback_session_id\n    log_params\n    resumePoint\n    error {\n      type\n      message\n      code\n    }\n    entitlements {\n      ...entitlementFields\n    }\n  }\n}\n    ", ""])), EntitlementFieldsFragmentDoc);
/**
 * __usePlaybackAuthQuery__
 *
 * To run a query within a React component, call `usePlaybackAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybackAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybackAuthQuery({
 *   variables: {
 *      id: // value for 'id'
 *      vuid: // value for 'vuid'
 *      sessionId: // value for 'sessionId'
 *      fl: // value for 'fl'
 *   },
 * });
 */

export function usePlaybackAuthQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PlaybackAuthDocument, options);
}
export function usePlaybackAuthLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PlaybackAuthDocument, options);
}
export var PlaybackSessionOpenDocument = gql(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n    mutation PlaybackSessionOpen($videoId: String, $sessionId: String) {\n  playbackSessionOpen(videoId: $videoId, sessionId: $sessionId) {\n    media\n    error {\n      type\n      message\n      code\n    }\n  }\n}\n    "])));

/**
 * __usePlaybackSessionOpenMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionOpenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionOpenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionOpenMutation, { data, loading, error }] = usePlaybackSessionOpenMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function usePlaybackSessionOpenMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PlaybackSessionOpenDocument, options);
}
export var PlaybackSessionCheckDocument = gql(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n    mutation PlaybackSessionCheck($sessionId: String) {\n  playbackSessionCheck(sessionId: $sessionId) {\n    result\n  }\n}\n    "])));

/**
 * __usePlaybackSessionCheckMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionCheckMutation, { data, loading, error }] = usePlaybackSessionCheckMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function usePlaybackSessionCheckMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PlaybackSessionCheckDocument, options);
}
export var PlaybackSessionCloseDocument = gql(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n    mutation PlaybackSessionClose($sessionId: String) {\n  playbackSessionClose(sessionId: $sessionId) {\n    result\n  }\n}\n    "])));

/**
 * __usePlaybackSessionCloseMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionCloseMutation, { data, loading, error }] = usePlaybackSessionCloseMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function usePlaybackSessionCloseMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PlaybackSessionCloseDocument, options);
}
export var ProductByIdDocument = gql(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n    query ProductById($id: Int) {\n  product: productById(id: $id) {\n    ...productFields\n    purchased\n    right {\n      ... on Right {\n        ...rightFields\n      }\n    }\n    meta {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n  }\n  broadcastDiscount(productId: $id) {\n    result\n    user_voucher_id\n  }\n}\n    ", "\n", "\n", "\n", ""])), ProductFieldsFragmentDoc, RightFieldsFragmentDoc, EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc);
/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */

export function useProductByIdQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ProductByIdDocument, options);
}
export function useProductByIdLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ProductByIdDocument, options);
}
export var PurchaseEstimateDocument = gql(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n    query PurchaseEstimate($productId: Int, $paymentMethodId: Int) {\n  estimate: purchaseEstimate(\n    productId: $productId\n    paymentMethodId: $paymentMethodId\n  ) {\n    product {\n      ... on Product {\n        ...productFields\n        voucherCode {\n          ... on VoucherCode {\n            ...voucherCodeFields\n          }\n        }\n      }\n    }\n    error\n  }\n}\n    ", "\n", ""])), ProductFieldsFragmentDoc, VoucherCodeFieldsFragmentDoc);
/**
 * __usePurchaseEstimateQuery__
 *
 * To run a query within a React component, call `usePurchaseEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseEstimateQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */

export function usePurchaseEstimateQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PurchaseEstimateDocument, options);
}
export function usePurchaseEstimateLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PurchaseEstimateDocument, options);
}
export var PurchaseEstimateWithCouponDocument = gql(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n    query PurchaseEstimateWithCoupon($productId: Int, $paymentMethodId: Int, $voucherCode: String, $userVoucherId: Int) {\n  estimateWithCoupon: purchaseEstimate(\n    productId: $productId\n    paymentMethodId: $paymentMethodId\n    voucherCode: $voucherCode\n    userVoucherId: $userVoucherId\n  ) {\n    product {\n      ... on Product {\n        ...productFields\n        voucherCode {\n          ... on VoucherCode {\n            ...voucherCodeFields\n          }\n        }\n        discountPrice\n      }\n    }\n    error\n  }\n}\n    ", "\n", ""])), ProductFieldsFragmentDoc, VoucherCodeFieldsFragmentDoc);
/**
 * __usePurchaseEstimateWithCouponQuery__
 *
 * To run a query within a React component, call `usePurchaseEstimateWithCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseEstimateWithCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseEstimateWithCouponQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      voucherCode: // value for 'voucherCode'
 *      userVoucherId: // value for 'userVoucherId'
 *   },
 * });
 */

export function usePurchaseEstimateWithCouponQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(PurchaseEstimateWithCouponDocument, options);
}
export function usePurchaseEstimateWithCouponLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(PurchaseEstimateWithCouponDocument, options);
}
export var PurchaseExecuteDocument = gql(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n    mutation PurchaseExecute($productId: Int, $paymentInstrumentId: Int, $voucherCode: String, $userVoucherId: Int) {\n  purchaseExecute(\n    productId: $productId\n    paymentInstrumentId: $paymentInstrumentId\n    voucherCode: $voucherCode\n    userVoucherId: $userVoucherId\n  ) {\n    product_order_id\n    product_id\n    status\n    name\n    created_at\n    error\n    order {\n      order_id\n      payment_method_id\n      payment_amount\n    }\n  }\n}\n    "])));

/**
 * __usePurchaseExecuteMutation__
 *
 * To run a mutation, you first call `usePurchaseExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseExecuteMutation, { data, loading, error }] = usePurchaseExecuteMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *      userVoucherId: // value for 'userVoucherId'
 *   },
 * });
 */
export function usePurchaseExecuteMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(PurchaseExecuteDocument, options);
}
export var RankingDocument = gql(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n    query ranking($target: String, $range: String, $channel: Int, $count: Int) {\n  ranking(target: $target, range: $range, channel: $channel, count: $count) {\n    id\n    rank\n    meta {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n  }\n}\n    ", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc);
/**
 * __useRankingQuery__
 *
 * To run a query within a React component, call `useRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankingQuery({
 *   variables: {
 *      target: // value for 'target'
 *      range: // value for 'range'
 *      channel: // value for 'channel'
 *      count: // value for 'count'
 *   },
 * });
 */

export function useRankingQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(RankingDocument, options);
}
export function useRankingLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(RankingDocument, options);
}
export var RecommendArticleDocument = gql(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n    query RecommendArticle {\n  recommendArticle {\n    ... on RecommendArticle {\n      ...recommendArticleFields\n    }\n  }\n}\n    ", ""])), RecommendArticleFieldsFragmentDoc);
/**
 * __useRecommendArticleQuery__
 *
 * To run a query within a React component, call `useRecommendArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendArticleQuery({
 *   variables: {
 *   },
 * });
 */

export function useRecommendArticleQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(RecommendArticleDocument, options);
}
export function useRecommendArticleLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(RecommendArticleDocument, options);
}
export var UpdateRecommendArticleDocument = gql(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n    mutation UpdateRecommendArticle($type: String!, $id: [Int]) {\n  updateRecommendArticle(type: $type, id: $id) {\n    ... on RecommendArticle {\n      ...recommendArticleFields\n    }\n  }\n}\n    ", ""])), RecommendArticleFieldsFragmentDoc);

/**
 * __useUpdateRecommendArticleMutation__
 *
 * To run a mutation, you first call `useUpdateRecommendArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecommendArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecommendArticleMutation, { data, loading, error }] = useUpdateRecommendArticleMutation({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateRecommendArticleMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(UpdateRecommendArticleDocument, options);
}
export var ClearRecommendArticleDocument = gql(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n    mutation ClearRecommendArticle {\n  clearRecommendArticle {\n    ... on RecommendArticle {\n      ...recommendArticleFields\n    }\n  }\n}\n    ", ""])), RecommendArticleFieldsFragmentDoc);

/**
 * __useClearRecommendArticleMutation__
 *
 * To run a mutation, you first call `useClearRecommendArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRecommendArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRecommendArticleMutation, { data, loading, error }] = useClearRecommendArticleMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearRecommendArticleMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(ClearRecommendArticleDocument, options);
}
export var RtTrackDocument = gql(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n    mutation RtTrack($location: String!, $referrer: String, $sid: String) {\n  track(location: $location, referrer: $referrer, sid: $sid) {\n    result\n  }\n}\n    "])));

/**
 * __useRtTrackMutation__
 *
 * To run a mutation, you first call `useRtTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRtTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rtTrackMutation, { data, loading, error }] = useRtTrackMutation({
 *   variables: {
 *      location: // value for 'location'
 *      referrer: // value for 'referrer'
 *      sid: // value for 'sid'
 *   },
 * });
 */
export function useRtTrackMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(RtTrackDocument, options);
}
export var RtRecommendDocument = gql(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n    query RtRecommend($location: String!, $elementIds: [String!]) {\n  recommend(location: $location, elementIds: $elementIds) {\n    elementId\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n        rtsid\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n        rtsid\n      }\n      ... on TVShowMeta {\n        ...tvShowMetaFields\n        rtsid\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, TvShowMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useRtRecommendQuery__
 *
 * To run a query within a React component, call `useRtRecommendQuery` and pass it any options that fit your needs.
 * When your component renders, `useRtRecommendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRtRecommendQuery({
 *   variables: {
 *      location: // value for 'location'
 *      elementIds: // value for 'elementIds'
 *   },
 * });
 */

export function useRtRecommendQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(RtRecommendDocument, options);
}
export function useRtRecommendLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(RtRecommendDocument, options);
}
export var SearchEpisodeDocument = gql(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n    query SearchEpisode($keyword: String, $filter: JSONObject, $sort: String, $offset: Int, $limit: Int, $minScore: Int) {\n  search(\n    keyword: $keyword\n    filter: $filter\n    sort: $sort\n    offset: $offset\n    limit: $limit\n    minScore: $minScore\n  ) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useSearchEpisodeQuery__
 *
 * To run a query within a React component, call `useSearchEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEpisodeQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      minScore: // value for 'minScore'
 *   },
 * });
 */

export function useSearchEpisodeQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SearchEpisodeDocument, options);
}
export function useSearchEpisodeLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SearchEpisodeDocument, options);
}
export var SearchTvShowDocument = gql(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n    query SearchTvShow($keyword: String, $filter: JSONObject, $sort: String, $offset: Int, $limit: Int, $minScore: Int) {\n  search: searchTvShow(\n    keyword: $keyword\n    filter: $filter\n    sort: $sort\n    offset: $offset\n    limit: $limit\n    minScore: $minScore\n  ) {\n    data {\n      ... on TVShowMeta {\n        ...tvShowMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", ""])), TvShowMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useSearchTvShowQuery__
 *
 * To run a query within a React component, call `useSearchTvShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTvShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTvShowQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      minScore: // value for 'minScore'
 *   },
 * });
 */

export function useSearchTvShowQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SearchTvShowDocument, options);
}
export function useSearchTvShowLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SearchTvShowDocument, options);
}
export var SearchConfigDocument = gql(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n    query SearchConfig {\n  searchConfig {\n    livePaletteKeywords\n    keywordMinScore {\n      keyword\n      score\n    }\n    defaultMinScore\n  }\n}\n    "])));
/**
 * __useSearchConfigQuery__
 *
 * To run a query within a React component, call `useSearchConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchConfigQuery({
 *   variables: {
 *   },
 * });
 */

export function useSearchConfigQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SearchConfigDocument, options);
}
export function useSearchConfigLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SearchConfigDocument, options);
}
export var SignupDocument = gql(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n    query Signup($adult: Boolean!) {\n  requiredTerms: registTerms(adult: $adult, type: REQUIRED) {\n    ...termsFields\n  }\n  optionalTerms: registTerms(adult: $adult, type: OPTIONAL) {\n    ...termsFields\n  }\n  recommendArticle {\n    courses {\n      ... on Course {\n        ...courseFields\n      }\n    }\n    products {\n      ... on Product {\n        ...productFields\n        right {\n          ... on Right {\n            ...rightFields\n          }\n        }\n      }\n    }\n  }\n}\n    ", "\n", "\n", "\n", ""])), TermsFieldsFragmentDoc, CourseFieldsFragmentDoc, ProductFieldsFragmentDoc, RightFieldsFragmentDoc);
/**
 * __useSignupQuery__
 *
 * To run a query within a React component, call `useSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupQuery({
 *   variables: {
 *      adult: // value for 'adult'
 *   },
 * });
 */

export function useSignupQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SignupDocument, options);
}
export function useSignupLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SignupDocument, options);
}
export var SubscribeDocument = gql(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n    mutation Subscribe($courseId: Int, $paymentInstrumentId: Int, $voucherCode: String, $campaignCode: String, $valuePlanTerm: String) {\n  subscribe(\n    courseId: $courseId\n    paymentInstrumentId: $paymentInstrumentId\n    campaignCode: $campaignCode\n    voucherCode: $voucherCode\n    valuePlanTerm: $valuePlanTerm\n  ) {\n    subscription_id\n    status\n    initialTransactionAt\n    trialStartAt\n    trialEndAt\n    init_order_id\n    course {\n      ...courseFields\n    }\n    error\n  }\n}\n    ", ""])), CourseFieldsFragmentDoc);

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *      campaignCode: // value for 'campaignCode'
 *      valuePlanTerm: // value for 'valuePlanTerm'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(SubscribeDocument, options);
}
export var SubscriptionsDocument = gql(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n    query Subscriptions {\n  subscriptions {\n    ...subscriptionFields\n  }\n}\n    ", ""])), SubscriptionFieldsFragmentDoc);
/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */

export function useSubscriptionsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SubscriptionsDocument, options);
}
export function useSubscriptionsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SubscriptionsDocument, options);
}
export var UnsubscribeDocument = gql(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n    query Unsubscribe($id: Int) {\n  subscription: subscriptionOne(id: $id) {\n    ...subscriptionFields\n  }\n  checkCancelable: subscriptionCheckCancelable(subscriptionId: $id) {\n    cancelable\n    subscription {\n      withdraw_at\n    }\n  }\n}\n    ", ""])), SubscriptionFieldsFragmentDoc);
/**
 * __useUnsubscribeQuery__
 *
 * To run a query within a React component, call `useUnsubscribeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnsubscribeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */

export function useUnsubscribeQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(UnsubscribeDocument, options);
}
export function useUnsubscribeLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(UnsubscribeDocument, options);
}
export var FormQuestionsDocument = gql(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n    query FormQuestions($id: Int) {\n  formQuestions(id: $id) {\n    question_id\n    data {\n      type\n      label\n      unique\n      key_name\n      help_text\n      required\n      options {\n        label\n        value\n      }\n    }\n  }\n}\n    "])));
/**
 * __useFormQuestionsQuery__
 *
 * To run a query within a React component, call `useFormQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */

export function useFormQuestionsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(FormQuestionsDocument, options);
}
export function useFormQuestionsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(FormQuestionsDocument, options);
}
export var SubscriptionCancelDocument = gql(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n    mutation SubscriptionCancel($id: Int, $questionId: Int, $answer: String, $withQuestionAnswer: Boolean = false) {\n  subscriptionCancel(id: $id) {\n    course_id\n    status\n    withdraw_at\n    error\n  }\n  formQuestionAnswer(id: $questionId, values: $answer) @include(if: $withQuestionAnswer) {\n    answer_id\n  }\n}\n    "])));

/**
 * __useSubscriptionCancelMutation__
 *
 * To run a mutation, you first call `useSubscriptionCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCancelMutation, { data, loading, error }] = useSubscriptionCancelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionId: // value for 'questionId'
 *      answer: // value for 'answer'
 *      withQuestionAnswer: // value for 'withQuestionAnswer'
 *   },
 * });
 */
export function useSubscriptionCancelMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(SubscriptionCancelDocument, options);
}
export var SubscriptionChangePaymentDocument = gql(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n    mutation SubscriptionChangePayment($paymentInstrumentId: Int!, $subscriptionId: Int!) {\n  subscriptionChangePayment(\n    paymentInstrumentId: $paymentInstrumentId\n    subscriptionId: $subscriptionId\n  ) {\n    payment_instrument_id\n    error\n  }\n}\n    "])));

/**
 * __useSubscriptionChangePaymentMutation__
 *
 * To run a mutation, you first call `useSubscriptionChangePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionChangePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionChangePaymentMutation, { data, loading, error }] = useSubscriptionChangePaymentMutation({
 *   variables: {
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscriptionChangePaymentMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(SubscriptionChangePaymentDocument, options);
}
export var SubscriptionCheckCancelableDocument = gql(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n    query SubscriptionCheckCancelable($subscriptionId: Int) {\n  checkCancelable: subscriptionCheckCancelable(subscriptionId: $subscriptionId) {\n    cancelable\n    subscription {\n      withdraw_at\n    }\n  }\n}\n    "])));
/**
 * __useSubscriptionCheckCancelableQuery__
 *
 * To run a query within a React component, call `useSubscriptionCheckCancelableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCheckCancelableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCheckCancelableQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */

export function useSubscriptionCheckCancelableQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SubscriptionCheckCancelableDocument, options);
}
export function useSubscriptionCheckCancelableLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SubscriptionCheckCancelableDocument, options);
}
export var FormQuestionAnswerDocument = gql(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n    mutation FormQuestionAnswer($values: String, $id: Int) {\n  formQuestionAnswer(values: $values, id: $id) {\n    answer_id\n  }\n}\n    "])));

/**
 * __useFormQuestionAnswerMutation__
 *
 * To run a mutation, you first call `useFormQuestionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormQuestionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formQuestionAnswerMutation, { data, loading, error }] = useFormQuestionAnswerMutation({
 *   variables: {
 *      values: // value for 'values'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormQuestionAnswerMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(FormQuestionAnswerDocument, options);
}
export var SubscriptionStatusDocument = gql(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n    query SubscriptionStatus($courseId: Int) {\n  course: courseById(courseId: $courseId) {\n    ... on Course {\n      ...courseFields\n    }\n    channel {\n      id\n      name\n    }\n  }\n  subscriptionStatus(courseId: $courseId) {\n    is_contractable\n    is_contracted\n    have_be_contracted\n    is_trial_enabled\n    subscription {\n      ...subscriptionFields\n    }\n  }\n  broadcastDiscount(courseId: $courseId) {\n    result\n    user_voucher_id\n  }\n}\n    ", "\n", ""])), CourseFieldsFragmentDoc, SubscriptionFieldsFragmentDoc);
/**
 * __useSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionStatusQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */

export function useSubscriptionStatusQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SubscriptionStatusDocument, options);
}
export function useSubscriptionStatusLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SubscriptionStatusDocument, options);
}
export var SubscriptionEstimateDocument = gql(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n    query SubscriptionEstimate($courseId: Int, $paymentMethodId: Int) {\n  estimate: subscriptionEstimate(\n    courseId: $courseId\n    paymentMethodId: $paymentMethodId\n  ) {\n    ...estimateFields\n  }\n}\n    ", ""])), EstimateFieldsFragmentDoc);
/**
 * __useSubscriptionEstimateQuery__
 *
 * To run a query within a React component, call `useSubscriptionEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEstimateQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */

export function useSubscriptionEstimateQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SubscriptionEstimateDocument, options);
}
export function useSubscriptionEstimateLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SubscriptionEstimateDocument, options);
}
export var SubscriptionEstimateWithCouponDocument = gql(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n    query SubscriptionEstimateWithCoupon($courseId: Int, $paymentMethodId: Int, $couponCode: String) {\n  estimateWithCoupon: subscriptionEstimate(\n    courseId: $courseId\n    paymentMethodId: $paymentMethodId\n    couponCode: $couponCode\n  ) {\n    ...estimateFields\n  }\n}\n    ", ""])), EstimateFieldsFragmentDoc);
/**
 * __useSubscriptionEstimateWithCouponQuery__
 *
 * To run a query within a React component, call `useSubscriptionEstimateWithCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEstimateWithCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEstimateWithCouponQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */

export function useSubscriptionEstimateWithCouponQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SubscriptionEstimateWithCouponDocument, options);
}
export function useSubscriptionEstimateWithCouponLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SubscriptionEstimateWithCouponDocument, options);
}
export var TermsDocument = gql(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n    query Terms($keys: [String], $adult: Boolean, $withAgreement: Boolean = false) {\n  terms(keys: $keys, adult: $adult, withAgreement: $withAgreement) {\n    ...termsFields\n  }\n}\n    ", ""])), TermsFieldsFragmentDoc);
/**
 * __useTermsQuery__
 *
 * To run a query within a React component, call `useTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *      adult: // value for 'adult'
 *      withAgreement: // value for 'withAgreement'
 *   },
 * });
 */

export function useTermsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(TermsDocument, options);
}
export function useTermsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(TermsDocument, options);
}
export var ValuePlanTermsDocument = gql(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n    query ValuePlanTerms {\n  terms(keys: [\"valueplan_term\"], adult: false, withAgreement: true) {\n    ...termsFields\n  }\n}\n    ", ""])), TermsFieldsFragmentDoc);
/**
 * __useValuePlanTermsQuery__
 *
 * To run a query within a React component, call `useValuePlanTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuePlanTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuePlanTermsQuery({
 *   variables: {
 *   },
 * });
 */

export function useValuePlanTermsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ValuePlanTermsDocument, options);
}
export function useValuePlanTermsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ValuePlanTermsDocument, options);
}
export var MySkpTermsDocument = gql(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n    query MySkpTerms {\n  terms(keys: [\"myskp\"], adult: false, withAgreement: false) {\n    ...termsFields\n  }\n}\n    ", ""])), TermsFieldsFragmentDoc);
/**
 * __useMySkpTermsQuery__
 *
 * To run a query within a React component, call `useMySkpTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySkpTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySkpTermsQuery({
 *   variables: {
 *   },
 * });
 */

export function useMySkpTermsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(MySkpTermsDocument, options);
}
export function useMySkpTermsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(MySkpTermsDocument, options);
}
export var RegistTermsDocument = gql(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n    query RegistTerms($adult: Boolean!) {\n  required: registTerms(adult: $adult, type: REQUIRED) {\n    ...termsFields\n  }\n  optional: registTerms(adult: $adult, type: OPTIONAL) {\n    ...termsFields\n  }\n}\n    ", ""])), TermsFieldsFragmentDoc);
/**
 * __useRegistTermsQuery__
 *
 * To run a query within a React component, call `useRegistTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistTermsQuery({
 *   variables: {
 *      adult: // value for 'adult'
 *   },
 * });
 */

export function useRegistTermsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(RegistTermsDocument, options);
}
export function useRegistTermsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(RegistTermsDocument, options);
}
export var LoginTermsDocument = gql(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n    query LoginTerms($adult: Boolean!) {\n  required: loginTerms(adult: $adult, type: REQUIRED) {\n    ...termsFields\n  }\n  optional: loginTerms(adult: $adult, type: OPTIONAL) {\n    ...termsFields\n  }\n}\n    ", ""])), TermsFieldsFragmentDoc);
/**
 * __useLoginTermsQuery__
 *
 * To run a query within a React component, call `useLoginTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginTermsQuery({
 *   variables: {
 *      adult: // value for 'adult'
 *   },
 * });
 */

export function useLoginTermsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(LoginTermsDocument, options);
}
export function useLoginTermsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(LoginTermsDocument, options);
}
export var TermsAgreeDocument = gql(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n    mutation TermsAgree($keys: [String]) {\n  agree(keys: $keys) {\n    unique_key\n    number\n    url\n    agreement {\n      agreement_id\n      user_id\n      term_id\n      term_revision_number\n    }\n  }\n}\n    "])));

/**
 * __useTermsAgreeMutation__
 *
 * To run a mutation, you first call `useTermsAgreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTermsAgreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [termsAgreeMutation, { data, loading, error }] = useTermsAgreeMutation({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useTermsAgreeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(TermsAgreeDocument, options);
}
export var TitleDocument = gql(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n    query Title($id: Int, $withBookmark: Boolean = false, $withChildren: Boolean = false, $withCourse: Boolean = false) {\n  title(id: $id) {\n    ...tvShowMetaFields\n    bookmark @include(if: $withBookmark) {\n      meta_id\n      bookmark_meta_id\n      position\n      bookmark_meta {\n        ...episodeMetaFields\n        ...liveMetaFields\n      }\n    }\n    course @include(if: $withCourse) {\n      ...courseFields\n    }\n  }\n  children(id: $id, offset: 0, limit: 10) @include(if: $withChildren) {\n    data {\n      ...episodeMetaFields\n      ...liveMetaFields\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", ""])), TvShowMetaFieldsFragmentDoc, EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, CourseFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useTitleQuery__
 *
 * To run a query within a React component, call `useTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withBookmark: // value for 'withBookmark'
 *      withChildren: // value for 'withChildren'
 *      withCourse: // value for 'withCourse'
 *   },
 * });
 */

export function useTitleQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(TitleDocument, options);
}
export function useTitleLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(TitleDocument, options);
}
export var TitlesDocument = gql(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n    query Titles($filter: JSONObject, $sort: String, $offset: Int, $limit: Int) {\n  titles(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {\n    data {\n      ...tvShowMetaFields\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", ""])), TvShowMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useTitlesQuery__
 *
 * To run a query within a React component, call `useTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useTitlesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(TitlesDocument, options);
}
export function useTitlesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(TitlesDocument, options);
}
export var AuthLoginDocument = gql(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n    mutation AuthLogin($loginid: String!, $password: String!, $rememberme: Boolean, $signature: String!) {\n  login(\n    loginid: $loginid\n    password: $password\n    rememberme: $rememberme\n    signature: $signature\n  ) {\n    token\n    user {\n      ...accountFields\n    }\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useAuthLoginMutation__
 *
 * To run a mutation, you first call `useAuthLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginMutation, { data, loading, error }] = useAuthLoginMutation({
 *   variables: {
 *      loginid: // value for 'loginid'
 *      password: // value for 'password'
 *      rememberme: // value for 'rememberme'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useAuthLoginMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AuthLoginDocument, options);
}
export var AuthUserDocument = gql(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n    query AuthUser {\n  user {\n    ...accountFields\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);
/**
 * __useAuthUserQuery__
 *
 * To run a query within a React component, call `useAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserQuery({
 *   variables: {
 *   },
 * });
 */

export function useAuthUserQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(AuthUserDocument, options);
}
export function useAuthUserLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(AuthUserDocument, options);
}
export var AuthUserWithFavoritesDocument = gql(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n    query AuthUserWithFavorites {\n  user {\n    ...accountFields\n  }\n  favorites: userFavorites {\n    ...userFavoritesFields\n  }\n}\n    ", "\n", ""])), AccountFieldsFragmentDoc, UserFavoritesFieldsFragmentDoc);
/**
 * __useAuthUserWithFavoritesQuery__
 *
 * To run a query within a React component, call `useAuthUserWithFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserWithFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserWithFavoritesQuery({
 *   variables: {
 *   },
 * });
 */

export function useAuthUserWithFavoritesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(AuthUserWithFavoritesDocument, options);
}
export function useAuthUserWithFavoritesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(AuthUserWithFavoritesDocument, options);
}
export var AuthLogoutDocument = gql(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n    mutation AuthLogout($force: Boolean = false) {\n  logout(force: $force) {\n    result\n  }\n}\n    "])));

/**
 * __useAuthLogoutMutation__
 *
 * To run a mutation, you first call `useAuthLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLogoutMutation, { data, loading, error }] = useAuthLogoutMutation({
 *   variables: {
 *      force: // value for 'force'
 *   },
 * });
 */
export function useAuthLogoutMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AuthLogoutDocument, options);
}
export var AuthSelectProfileDocument = gql(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n    mutation AuthSelectProfile($profileId: Int!, $passcode: String, $type: String) {\n  selectProfile(profileId: $profileId, passcode: $passcode, type: $type) {\n    ...accountFields\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useAuthSelectProfileMutation__
 *
 * To run a mutation, you first call `useAuthSelectProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSelectProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSelectProfileMutation, { data, loading, error }] = useAuthSelectProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      passcode: // value for 'passcode'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAuthSelectProfileMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AuthSelectProfileDocument, options);
}
export var AuthProfileDocument = gql(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n    mutation AuthProfile($profileId: Int, $passcode: String) {\n  authProfile(profileId: $profileId, passcode: $passcode) {\n    result\n  }\n}\n    "])));

/**
 * __useAuthProfileMutation__
 *
 * To run a mutation, you first call `useAuthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authProfileMutation, { data, loading, error }] = useAuthProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */
export function useAuthProfileMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AuthProfileDocument, options);
}
export var AccountSignupPinCodeDocument = gql(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n    mutation AccountSignupPinCode($mailAddress: String!) {\n  signupPincode(mailAddress: $mailAddress) {\n    result\n  }\n}\n    "])));

/**
 * __useAccountSignupPinCodeMutation__
 *
 * To run a mutation, you first call `useAccountSignupPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSignupPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSignupPinCodeMutation, { data, loading, error }] = useAccountSignupPinCodeMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */
export function useAccountSignupPinCodeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountSignupPinCodeDocument, options);
}
export var AccountSendPinCodeDocument = gql(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n    mutation AccountSendPinCode($mailAddress: String!) {\n  sendPincode(mailAddress: $mailAddress) {\n    result\n  }\n}\n    "])));

/**
 * __useAccountSendPinCodeMutation__
 *
 * To run a mutation, you first call `useAccountSendPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendPinCodeMutation, { data, loading, error }] = useAccountSendPinCodeMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */
export function useAccountSendPinCodeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountSendPinCodeDocument, options);
}
export var AccountSendProfilePinResetTokenDocument = gql(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n    mutation AccountSendProfilePinResetToken {\n  sendProfilePinResetToken {\n    result\n  }\n}\n    "])));

/**
 * __useAccountSendProfilePinResetTokenMutation__
 *
 * To run a mutation, you first call `useAccountSendProfilePinResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendProfilePinResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendProfilePinResetTokenMutation, { data, loading, error }] = useAccountSendProfilePinResetTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useAccountSendProfilePinResetTokenMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountSendProfilePinResetTokenDocument, options);
}
export var AccountSendPasswordResetTokenDocument = gql(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n    mutation AccountSendPasswordResetToken($mailAddress: String!) {\n  sendPasswordResetToken(mailAddress: $mailAddress) {\n    result\n  }\n}\n    "])));

/**
 * __useAccountSendPasswordResetTokenMutation__
 *
 * To run a mutation, you first call `useAccountSendPasswordResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendPasswordResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendPasswordResetTokenMutation, { data, loading, error }] = useAccountSendPasswordResetTokenMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */
export function useAccountSendPasswordResetTokenMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountSendPasswordResetTokenDocument, options);
}
export var AccountPasswordResetDocument = gql(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n    mutation AccountPasswordReset($password: String!, $token: String!) {\n  passwordReset(password: $password, token: $token) {\n    result\n  }\n}\n    "])));

/**
 * __useAccountPasswordResetMutation__
 *
 * To run a mutation, you first call `useAccountPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasswordResetMutation, { data, loading, error }] = useAccountPasswordResetMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountPasswordResetMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountPasswordResetDocument, options);
}
export var AccountPasscodeResetDocument = gql(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["\n    mutation AccountPasscodeReset($passcode: String!, $token: String!) {\n  passcodeReset(passcode: $passcode, token: $token) {\n    result\n  }\n}\n    "])));

/**
 * __useAccountPasscodeResetMutation__
 *
 * To run a mutation, you first call `useAccountPasscodeResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasscodeResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasscodeResetMutation, { data, loading, error }] = useAccountPasscodeResetMutation({
 *   variables: {
 *      passcode: // value for 'passcode'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountPasscodeResetMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountPasscodeResetDocument, options);
}
export var AccountVerifyPinCodeDocument = gql(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["\n    mutation AccountVerifyPinCode($code: String!, $mailAddress: String!) {\n  verifyPinCode(code: $code, mailAddress: $mailAddress) {\n    verified\n    error\n  }\n}\n    "])));

/**
 * __useAccountVerifyPinCodeMutation__
 *
 * To run a mutation, you first call `useAccountVerifyPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyPinCodeMutation, { data, loading, error }] = useAccountVerifyPinCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */
export function useAccountVerifyPinCodeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountVerifyPinCodeDocument, options);
}
export var AccountVerifyPasswordTokenDocument = gql(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["\n    mutation AccountVerifyPasswordToken($token: String!) {\n  verifyPasswordToken(token: $token) {\n    verified\n    error\n  }\n}\n    "])));

/**
 * __useAccountVerifyPasswordTokenMutation__
 *
 * To run a mutation, you first call `useAccountVerifyPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyPasswordTokenMutation, { data, loading, error }] = useAccountVerifyPasswordTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountVerifyPasswordTokenMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountVerifyPasswordTokenDocument, options);
}
export var AccountSignupDocument = gql(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["\n    mutation AccountSignup($code: String!, $mailAddress: String!, $password: String!, $firstName: String!, $lastName: String!, $birthday: String!, $sex: String!, $terms: String!, $signature: String!) {\n  signup(\n    code: $code\n    mailAddress: $mailAddress\n    password: $password\n    firstName: $firstName\n    lastName: $lastName\n    birthday: $birthday\n    sex: $sex\n    terms: $terms\n    signature: $signature\n  ) {\n    token\n    user {\n      ...accountFields\n    }\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useAccountSignupMutation__
 *
 * To run a mutation, you first call `useAccountSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSignupMutation, { data, loading, error }] = useAccountSignupMutation({
 *   variables: {
 *      code: // value for 'code'
 *      mailAddress: // value for 'mailAddress'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      terms: // value for 'terms'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useAccountSignupMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountSignupDocument, options);
}
export var AddFavoriteDocument = gql(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["\n    mutation AddFavorite($id: Int!) {\n  addFavorite(id: $id) {\n    result\n    favorites {\n      ...userFavoritesFields\n    }\n  }\n}\n    ", ""])), UserFavoritesFieldsFragmentDoc);

/**
 * __useAddFavoriteMutation__
 *
 * To run a mutation, you first call `useAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteMutation, { data, loading, error }] = useAddFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddFavoriteMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AddFavoriteDocument, options);
}
export var DeleteFavoriteDocument = gql(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["\n    mutation DeleteFavorite($id: Int!) {\n  deleteFavorite(id: $id) {\n    result\n    favorites {\n      ...userFavoritesFields\n    }\n  }\n}\n    ", ""])), UserFavoritesFieldsFragmentDoc);

/**
 * __useDeleteFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteMutation, { data, loading, error }] = useDeleteFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFavoriteMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(DeleteFavoriteDocument, options);
}
export var FavoritesByContentTypeDocument = gql(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral(["\n    query FavoritesByContentType($type: String, $offset: Int, $limit: Int) {\n  favorites: favoritesByContentType(type: $type, offset: $offset, limit: $limit) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n      }\n      ... on TVShowMeta {\n        ...tvShowMetaFields\n      }\n      ... on ChannelMeta {\n        ...channelMetaFields\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, TvShowMetaFieldsFragmentDoc, ChannelMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useFavoritesByContentTypeQuery__
 *
 * To run a query within a React component, call `useFavoritesByContentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesByContentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesByContentTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useFavoritesByContentTypeQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(FavoritesByContentTypeDocument, options);
}
export function useFavoritesByContentTypeLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(FavoritesByContentTypeDocument, options);
}
export var ViewingHistoriesDocument = gql(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["\n    query ViewingHistories($offset: Int, $limit: Int, $sort: String, $nocache: Boolean = false) {\n  viewingHistories(offset: $offset, limit: $limit, sort: $sort, nocache: $nocache) {\n    data {\n      ... on EpisodeMeta {\n        ...episodeMetaFields\n        resume_point\n        last_viewing_at\n      }\n      ... on LiveMeta {\n        ...liveMetaFields\n        resume_point\n        last_viewing_at\n      }\n    }\n    pageInfo {\n      ...pageInfoFields\n    }\n  }\n}\n    ", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, PageInfoFieldsFragmentDoc);
/**
 * __useViewingHistoriesQuery__
 *
 * To run a query within a React component, call `useViewingHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewingHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewingHistoriesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      nocache: // value for 'nocache'
 *   },
 * });
 */

export function useViewingHistoriesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ViewingHistoriesDocument, options);
}
export function useViewingHistoriesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ViewingHistoriesDocument, options);
}
export var DeleteViewingHistoryDocument = gql(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n    mutation DeleteViewingHistory($metaIds: [String]) {\n  deleteViewingHistory(metaIds: $metaIds) {\n    result\n  }\n}\n    "])));

/**
 * __useDeleteViewingHistoryMutation__
 *
 * To run a mutation, you first call `useDeleteViewingHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewingHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewingHistoryMutation, { data, loading, error }] = useDeleteViewingHistoryMutation({
 *   variables: {
 *      metaIds: // value for 'metaIds'
 *   },
 * });
 */
export function useDeleteViewingHistoryMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(DeleteViewingHistoryDocument, options);
}
export var AddResumeDocument = gql(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["\n    mutation AddResume($resume: Int, $metaId: Int, $groupedMetaId: Int, $psid: String, $reachToEnd: Boolean) {\n  addResume(\n    resume: $resume\n    metaId: $metaId\n    groupedMetaId: $groupedMetaId\n    psid: $psid\n    reachToEnd: $reachToEnd\n  ) {\n    result\n  }\n}\n    "])));

/**
 * __useAddResumeMutation__
 *
 * To run a mutation, you first call `useAddResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeMutation, { data, loading, error }] = useAddResumeMutation({
 *   variables: {
 *      resume: // value for 'resume'
 *      metaId: // value for 'metaId'
 *      groupedMetaId: // value for 'groupedMetaId'
 *      psid: // value for 'psid'
 *      reachToEnd: // value for 'reachToEnd'
 *   },
 * });
 */
export function useAddResumeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AddResumeDocument, options);
}
export var AccountUpdateDocument = gql(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["\n    mutation AccountUpdate($mailAddress: String, $code: String) {\n  update(mailAddress: $mailAddress, code: $code) {\n    user {\n      ...accountFields\n    }\n    error\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateMutation, { data, loading, error }] = useAccountUpdateMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAccountUpdateMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountUpdateDocument, options);
}
export var AccountUpdatePasswordDocument = gql(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["\n    mutation AccountUpdatePassword($currentPassword: String, $password: String) {\n  updatePassword(currentPassword: $currentPassword, password: $password) {\n    user {\n      ...accountFields\n    }\n    error\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useAccountUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAccountUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdatePasswordMutation, { data, loading, error }] = useAccountUpdatePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAccountUpdatePasswordMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountUpdatePasswordDocument, options);
}
export var AccountUpdateOwnerProfileDocument = gql(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["\n    mutation AccountUpdateOwnerProfile($displayName: String, $icon: Int, $passcode: String, $rating: Int) {\n  updateOwnerProfile(\n    displayName: $displayName\n    icon: $icon\n    passcode: $passcode\n    rating: $rating\n  ) {\n    user {\n      ...accountFields\n    }\n    error\n  }\n}\n    ", ""])), AccountFieldsFragmentDoc);

/**
 * __useAccountUpdateOwnerProfileMutation__
 *
 * To run a mutation, you first call `useAccountUpdateOwnerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateOwnerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateOwnerProfileMutation, { data, loading, error }] = useAccountUpdateOwnerProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      icon: // value for 'icon'
 *      passcode: // value for 'passcode'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useAccountUpdateOwnerProfileMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountUpdateOwnerProfileDocument, options);
}
export var AccountAddProfileDocument = gql(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["\n    mutation AccountAddProfile($displayName: String, $birthday: String, $sex: String, $icon: Int, $rating: Int, $passcode: String) {\n  addProfile(\n    displayName: $displayName\n    birthday: $birthday\n    sex: $sex\n    icon: $icon\n    rating: $rating\n    passcode: $passcode\n  ) {\n    profile {\n      ...profileFields\n    }\n  }\n}\n    ", ""])), ProfileFieldsFragmentDoc);

/**
 * __useAccountAddProfileMutation__
 *
 * To run a mutation, you first call `useAccountAddProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddProfileMutation, { data, loading, error }] = useAccountAddProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      icon: // value for 'icon'
 *      rating: // value for 'rating'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */
export function useAccountAddProfileMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountAddProfileDocument, options);
}
export var AccountUpdateProfileDocument = gql(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["\n    mutation AccountUpdateProfile($displayName: String, $birthday: String, $sex: String, $password: String, $profileId: Int, $icon: Int, $rating: Int, $passcode: String) {\n  updateProfile(\n    displayName: $displayName\n    birthday: $birthday\n    sex: $sex\n    password: $password\n    profileId: $profileId\n    icon: $icon\n    rating: $rating\n    passcode: $passcode\n  ) {\n    profile {\n      ...profileFields\n    }\n  }\n}\n    ", ""])), ProfileFieldsFragmentDoc);

/**
 * __useAccountUpdateProfileMutation__
 *
 * To run a mutation, you first call `useAccountUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateProfileMutation, { data, loading, error }] = useAccountUpdateProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      password: // value for 'password'
 *      profileId: // value for 'profileId'
 *      icon: // value for 'icon'
 *      rating: // value for 'rating'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */
export function useAccountUpdateProfileMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountUpdateProfileDocument, options);
}
export var AccountDeleteProfileDocument = gql(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["\n    mutation AccountDeleteProfile($profileId: Int) {\n  deleteProfile(profileId: $profileId) {\n    result\n  }\n}\n    "])));

/**
 * __useAccountDeleteProfileMutation__
 *
 * To run a mutation, you first call `useAccountDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountDeleteProfileMutation, { data, loading, error }] = useAccountDeleteProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useAccountDeleteProfileMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountDeleteProfileDocument, options);
}
export var AccountUserDeleteDocument = gql(_templateObject124 || (_templateObject124 = _taggedTemplateLiteral(["\n    mutation AccountUserDelete {\n  userDelete {\n    result\n  }\n}\n    "])));

/**
 * __useAccountUserDeleteMutation__
 *
 * To run a mutation, you first call `useAccountUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserDeleteMutation, { data, loading, error }] = useAccountUserDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useAccountUserDeleteMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AccountUserDeleteDocument, options);
}
export var AccountBroadcastDiscountDocument = gql(_templateObject125 || (_templateObject125 = _taggedTemplateLiteral(["\n    query AccountBroadcastDiscount($courseId: Int, $productId: Int) {\n  broadcastDiscount(courseId: $courseId, productId: $productId) {\n    result\n    user_voucher_id\n  }\n}\n    "])));
/**
 * __useAccountBroadcastDiscountQuery__
 *
 * To run a query within a React component, call `useAccountBroadcastDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBroadcastDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBroadcastDiscountQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      productId: // value for 'productId'
 *   },
 * });
 */

export function useAccountBroadcastDiscountQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(AccountBroadcastDiscountDocument, options);
}
export function useAccountBroadcastDiscountLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(AccountBroadcastDiscountDocument, options);
}
export var UserEntitlementsDocument = gql(_templateObject126 || (_templateObject126 = _taggedTemplateLiteral(["\n    query UserEntitlements {\n  entitlements: userEntitlements {\n    ...entitlementFields\n  }\n}\n    ", ""])), EntitlementFieldsFragmentDoc);
/**
 * __useUserEntitlementsQuery__
 *
 * To run a query within a React component, call `useUserEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEntitlementsQuery({
 *   variables: {
 *   },
 * });
 */

export function useUserEntitlementsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(UserEntitlementsDocument, options);
}
export function useUserEntitlementsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(UserEntitlementsDocument, options);
}
export var WatchDocument = gql(_templateObject127 || (_templateObject127 = _taggedTemplateLiteral(["\n    query Watch($id: Int) {\n  episode(id: $id) {\n    ...episodeMetaFields\n    ...liveMetaFields\n  }\n  nextEpisode(id: $id) {\n    ...episodeMetaFields\n    ...liveMetaFields\n  }\n  howtoPlay(id: $id) {\n    free\n    member_only\n    rights {\n      ...rightFields\n    }\n    courses {\n      ...courseFields\n    }\n    products {\n      ...productFields\n    }\n  }\n  entitlements(metaId: $id) {\n    ...entitlementFields\n  }\n  uid2Token {\n    token\n  }\n}\n    ", "\n", "\n", "\n", "\n", "\n", ""])), EpisodeMetaFieldsFragmentDoc, LiveMetaFieldsFragmentDoc, RightFieldsFragmentDoc, CourseFieldsFragmentDoc, ProductFieldsFragmentDoc, EntitlementFieldsFragmentDoc);
/**
 * __useWatchQuery__
 *
 * To run a query within a React component, call `useWatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */

export function useWatchQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(WatchDocument, options);
}
export function useWatchLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(WatchDocument, options);
}
export var WebPageDocument = gql(_templateObject128 || (_templateObject128 = _taggedTemplateLiteral(["\n    query WebPage($path: String) {\n  webPage(path: $path) {\n    id\n    content\n    style\n    script\n    metatags {\n      robots\n      canonicalUrl\n      title\n      keywords\n      description\n    }\n  }\n}\n    "])));
/**
 * __useWebPageQuery__
 *
 * To run a query within a React component, call `useWebPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebPageQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */

export function useWebPageQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(WebPageDocument, options);
}
export function useWebPageLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(WebPageDocument, options);
}